import {
  throwSubtypeNotRegistered2cr459177l268 as throwSubtypeNotRegistered,
  throwSubtypeNotRegistered343gt7v9eqwun as throwSubtypeNotRegistered_0,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
} from './internal/AbstractPolymorphicSerializer.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import {
  OPEN_getInstance3fojhnrvzj4l0 as OPEN_getInstance,
  CONTEXTUAL_getInstance20l1ap7hne5we as CONTEXTUAL_getInstance,
} from './descriptors/SerialKinds.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { serializer1x79l67jvwntn as serializer } from './builtins/BuiltinSerializers.mjs';
import { buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor } from './descriptors/SerialDescriptors.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { withContext3ge61vpog00ae as withContext } from './descriptors/ContextAware.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function findPolymorphicSerializer(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(klassName, _this__u8e3s4.get_baseClass_lygw3m_k$());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(getKClassFromExpression(value), _this__u8e3s4.get_baseClass_lygw3m_k$());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 7);
}
var PolymorphicSerializerClass;
function PolymorphicSerializer() {
  if (PolymorphicSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      constructor(baseClass) {
        return new.target.new_kotlinx_serialization_PolymorphicSerializer_2rg7t_k$(baseClass);
      }
      static new_kotlinx_serialization_PolymorphicSerializer_2rg7t_k$(baseClass) {
        var $this = this.new_kotlinx_serialization_internal_AbstractPolymorphicSerializer_mpc34r_k$();
        $this.baseClass_1 = baseClass;
        $this._annotations_1 = emptyList();
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.descriptor$delegate_1 = lazy(tmp_0, () => {
          var tmp = OPEN_getInstance();
          return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], ($this$buildSerialDescriptor) => {
            $this$buildSerialDescriptor.element$default_ey7ac9_k$('type', serializer(StringCompanionObject_instance).get_descriptor_wjt6a0_k$());
            $this$buildSerialDescriptor.element$default_ey7ac9_k$('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + $this.baseClass_1.get_simpleName_r6f8py_k$() + '>', CONTEXTUAL_getInstance(), []));
            $this$buildSerialDescriptor.annotations_1 = $this._annotations_1;
            return Unit_instance;
          }), $this.baseClass_1);
        });
        return $this;
      }
      get_baseClass_lygw3m_k$() {
        return this.baseClass_1;
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
        return tmp0.get_value_j01efc_k$();
      }
      toString() {
        return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.baseClass_1) + ')';
      }
    }
    initMetadataForClass($, 'PolymorphicSerializer');
    PolymorphicSerializerClass = $;
  }
  return PolymorphicSerializerClass;
}
//region block: exports
export {
  PolymorphicSerializer as PolymorphicSerializer3p3fzpdobi8hh,
  findPolymorphicSerializer as findPolymorphicSerializer1nm87hvemahcj,
  findPolymorphicSerializer_0 as findPolymorphicSerializerk638ixyjovk5,
};
//endregion

//# sourceMappingURL=PolymorphicSerializer.mjs.map
